export const NEAR_BY_ADDRESS_RADIUS_IN_MTR = process.env.NEAR_BY_ADDRESS_RADIUS_IN_MTR || 50000; // 50KM

// extend this to on cart load
export const enum FETCH_ADDRESS_LIST_SOURCE {
    ADD_OR_SELECT_CTA = "add_or_select_cta",
}

// market place source - https://github.com/swiggy-private/protorepo/blob/6fa9fb18bd11efb5c1226d4ee85852f05ecfeca4/platform/bundle-commons/marketplace/v1/marketplace.proto#L13
// entity source - https://github.com/swiggy-private/protorepo/blob/master/location-platform/central-address-service/v1/central_address_messages.proto#L26
export const CAS_NEARBY_ADDRESS_API_PARAMS = {
    MARKET_PLACE_ID: 1,
    MARKET_PLACE_BL: 0,
    ENTITY_TYPE: 1,
};

// Ref: https://swiggy.atlassian.net/wiki/spaces/MAPS/pages/3908108342/NearBy+Enriched+Addresses+API
export const CAS_API_HEADERS = {
    CLIENT_ID: "checkout-web-app",
    SOURCE: "web-cart",
};

export const ADDRESS_NUDGE_TOOLTIP_SESSION_STORAGE_KEY = "address_nudge_tooltip_shown";
